export default __webpack_public_path__ + "img/c27c0bb4a09fc5f8d167678358b91f99.png";